import { api } from "../../api";
import { TOP5_ENDPOINTS } from "../../../constants/endpoints";

export const top5Api = api.injectEndpoints({
  endpoints: (builder) => ({
    top5Init: builder.mutation({
      query: (payload) => ({
        url: TOP5_ENDPOINTS.INIT,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
    getAllTop5: builder.query({
      query: (payload) => ({
        url: TOP5_ENDPOINTS.GET_ALL,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
      providesTags: ["Top5"],
    }),
    createTop5: builder.mutation({
      query: (payload) => ({
        url: TOP5_ENDPOINTS.CREATE,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
    upsertTop5: builder.mutation({
      query: (payload) => ({
        url: TOP5_ENDPOINTS.UPSERT,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
    deleteTop5: builder.mutation({
      query: (payload) => ({
        url: TOP5_ENDPOINTS.DELETE,
        method: "POST",
        body: new URLSearchParams(payload).toString(),
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useTop5InitMutation,
  useGetAllTop5Query,
  useCreateTop5Mutation,
  useUpsertTop5Mutation,
  useDeleteTop5Mutation,
} = top5Api;
